<div class="file-action-bar">
  <span class="file-action-bar__count" [class.file-action-bar__count--visible]="selectedFiles.length > 0">
    {{ selectedFiles.length }} kijelölve
  </span>
</div>
